const PROJECTS = "projects";

export const projectsKeys = {
	create: [PROJECTS, "create"] as const,
	delete: [PROJECTS, "delete"] as const,
	data: (userId: string | null, projectId: string | null) =>
		[PROJECTS, "data", userId, projectId] as const,
	list: [PROJECTS, "list"] as const,
	saveData: [PROJECTS, "save-data"] as const,
	update: [PROJECTS, "update"] as const,
	updateSharing: [PROJECTS, "update-sharing"] as const,
};
